import React from 'react';

import ProfileForm from './EditProfilePage/EditProfile';

const EditProfile = () => {
  return <ProfileForm />;
};

export default EditProfile;
